
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  zynthSlide: false, 
};

const zynthSlice = createSlice({
  name: 'zynth',
  initialState,
  reducers: {
    toggleZynthSlide: (state) => {
      state.zynthSlide = !state.zynthSlide;
    },
    setZynthSlide: (state, action) => {
      state.zynthSlide = action.payload;
    },
  },
});

export const { toggleZynthSlide, setZynthSlide } = zynthSlice.actions;
export default zynthSlice.reducer;
